import React, { createRef, useEffect, useState } from "react";

import { ConfirmationResult, UserInfo } from "firebase/auth";

import { useMutation } from "@apollo/client";

import { useApolloClient } from "@apollo/client";

/** components */
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

/** services */
import { login, logout } from "./../services/auth";

/** context */
import { useSettings } from "../context/settings";

/** QUERIES & MUTATIONS */
import CREATE_USER from "../provider/Users/mutation";

/** utils */
import { getGraphsqErros, errorLoginPhoneFirebase, maskPhone, clearMask, sleep } from "./../utilities/functions";

import { PLANS } from "../provider/Plans/query";
import { useLocation, useParams } from "react-router-dom";
import { FRANCHISE } from "../provider/Franchises/query";
import { USER_LOGIN, USER_PASSWORD } from "../provider/Users/query";

const Window: any = global.window;

export const Login = (props: any) => {
  const recaptchaWrapperRef = createRef<HTMLDivElement>();
  const [createUser] = useMutation(CREATE_USER);

  const location = useLocation();

  const settings = useSettings();

  const params = useParams();

  const [loading, setLoading] = useState<boolean>(false);
  const [loadFranchise, setLoadFranchise] = useState<boolean>(true);
  const [submitted, setSubmitted] = useState<boolean>(false);

  const [changePassword, setChangePassword] = useState<boolean>(false);
  const [newPassword, setNewPassword] = useState<string>('');

  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [time, setTime] = useState(0);
  const [confirm, setConfirm] = useState(false);
  const apollo = useApolloClient();

  const [franchise, setFranchise] = useState<iFranchise>();
  const [franchiseAuth, setFranchiseAuth] = useState<any>();
  const [banner, setBanner] = useState('assets/layout/images/pages/login-onlight.png');
  const [logo, setLogo] = useState('assets/layout/images/logo-light.png');
  const [appName, setAppName] = useState('Vamos CAP');

  const [userApi, setUserApi] = useState<any>();
  const [userFirebase, setUserFirebase] = useState<any>();

  function _signInPhone() {
    setSubmitted(true);
    if (!phone) return;

    setLoading(true);

    if (clearMask(phone).length === 11) {
      setConfirm(true);
      setLoading(false);
      setSubmitted(false);
    } else {
      settings.setErrorMessage("Por favor, informe um telefone válido");
      settings.setVisibleError(true);

      setLoading(false);
      setSubmitted(false);
    }
  }

  function _confirmCodePhone() {
    setSubmitted(true);

    if (code.length !== 6) {
      settings.setErrorMessage("O código deve ter 6 dígitos");
      settings.setVisibleError(true);

      return;
    }

    setLoading(true);

    const variables: any = {
      phone,
      password: code,
    }

    if (franchise) variables.franchise_id = parseInt(`${franchise.id}`);

    if (params.callcenter) variables.is_callcenter = true;

    apollo
    .query({
      query: USER_LOGIN,
      variables,
      fetchPolicy: "no-cache",
    })
    .then(e => {
      setLoading(false);

      setUserApi(e.data.userLogin);

      if (!e.data.userLogin.password || e.data.userLogin.password === '123456') {
        login(e.data.userLogin);
        setChangePassword(true);
  
        settings.setErrorMessage("Crie um novo código");
        settings.setVisibleError(true);
  
        return;
      }

      if (e.data.userLogin.is_callcenter) {
        login(e.data.userLogin);
        return;
      }

      if (e.data.userLogin.is_root) {
        login(e.data.userLogin);
        document.location.href = "/";
      } else {
        settings.setErrorMessage("Solicite a liberação de seu acesso para o administrador.");
        settings.setVisibleError(true);
      }
    })
    .catch(e => {
      console.log('error: ', JSON.stringify(e));
      setLoading(false);
      settings.setErrorMessage(getGraphsqErros(e));
      settings.setVisibleError(true);
    });
  }

  function _changePassword() {
    setSubmitted(true);

    if (!userApi) return;

    if (userApi.password && userApi.password !== '123456') return;

    if (newPassword.length !== 6) {
      settings.setErrorMessage("O novo código deve ter 6 dígitos");
      settings.setVisibleError(true);

      return;
    }

    setLoading(true);

    const variables: any = {
      id: parseInt(`${userApi.id}`),
      password: newPassword,
    }

    if (franchise) variables.franchise_id = parseInt(`${franchise.id}`);

    apollo
    .query({
      query: USER_PASSWORD,
      variables,
      fetchPolicy: "no-cache",
    })
    .then(e => {
      setLoading(false);

      setUserApi(e.data.userPassword);

      if (e.data.userPassword.is_callcenter) {
        login(e.data.userPassword);

        return;
      }

      if (e.data.userPassword.is_root) {
        login(e.data.userPassword);
        document.location.href = "/";
      } else {
        settings.setErrorMessage("Solicite a liberação de seu acesso para o administrador.");
        settings.setVisibleError(true);
      }
    })
    .catch(e => {
      console.log('error: ', JSON.stringify(e));
      setLoading(false);
      settings.setErrorMessage(getGraphsqErros(e));
      settings.setVisibleError(true);
    })
    .finally(() => setChangePassword(false));
  }

  async function _userAuth(userData: UserInfo) {
    setLoading(true);

    const data: any = { phone: phone, uid: userData.uid };

    if (params.callcenter) {
      data.is_callcenter = true;
      data.franchise_id = Number(params.callcenter);
    }

    if (params.franchise) {
      data.franchise_id = Number(params.franchise);
    }

    createUser({ variables: { data } })
      .then(e => {
        setLoading(false);

        setUserApi(e.data.createUser);

        if (e.data.createUser.is_callcenter) {
          login(e.data.createUser);
          return;
        }

        if (e.data.createUser.is_root) {
          login(e.data.createUser);
          // document.location.href = "/";
        } else {
          settings.setErrorMessage("Solicite a liberação de seu acesso para o administrador.");
          settings.setVisibleError(true);
        }
      })
      .catch(e => {
        console.log('error: ', JSON.stringify(e));
        setLoading(false);
        settings.setErrorMessage(getGraphsqErros(e));
        settings.setVisibleError(true);
      });
  }

  function getTime() {
    return time;
  }

  useEffect(() => {
    if (time >= 0) {
      if (time > 0) {
        sleep(1000).then(e => {
          setTime(time - 1);
        });
      } else {
        setTime(0);
      }
    }
    return () => {
      // actions to be performed when component unmounts
    };
  }, [time]);

  useEffect(() => {
    if (!params.callcenter || !userApi) return;

    if (userApi.is_root) {
      document.location.href = "/";
      return;
    }

    if (changePassword) return;

    if (!userApi.passenger_id) {
      document.location.href = "/register";
      return;
    } else if (!userApi.acting_region_id) {
      settings.setErrorMessage("Solicite a liberação de seu acesso para o administrador.");
      settings.setVisibleError(true);
      logout();
      setUserApi(null);
      return;
    }

    document.location.href = "/";
  }, [userApi])

  useEffect(() => {
    apollo
    .query({
      query: PLANS,
      variables: {
        // limit: perPage,
        // filter: filter,
      },
      fetchPolicy: "no-cache",
    })
    .then(response => {
      const data = response.data.plans;
      setLoading(false);
    })
    .catch(error => {
      settings?.setErrorMessage(getGraphsqErros(error));
      settings?.setVisibleError(true);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (params.franchise || params.callcenter) {
      setLoadFranchise(true);
      apollo
      .query({
        query: FRANCHISE,
        variables: {
          id: Number(params.franchise || params.callcenter),
        },
        fetchPolicy: "no-cache",
      })
      .then(response => {
        const data = response.data.franchise;
        setFranchise(data);

        if (data.banner_path && data.banner_path !== '') setBanner(data.banner_path);
        if (data.logo_path && data.logo_path !== '') setLogo(data.logo_path);
        if (data.name && data.name !== '') setAppName(data.name);

        setLoading(false);
        setLoadFranchise(false);
      })
      .catch(error => {
        console.log('Login FRANCHISE error: ', JSON.stringify(error));
        settings?.setErrorMessage(getGraphsqErros(error));
        settings?.setVisibleError(true);
        setLoading(false);
      });
    } else {

      setLoadFranchise(false);
    }
  }, []);

  return (
    <div className="login-body">
      {loadFranchise ? (null) : (
        <div className="login-image">
          <img src={banner} alt={appName} />
        </div>
      )}

      <div className="login-panel p-fluid">
        {loadFranchise ? (
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '3rem' }} />
        ) : (
          !confirm ? (
            <form
              onSubmit={e => {
                e.preventDefault();
                _signInPhone();
              }}>
              <div className="flex flex-column">
                <div className="flex align-items-center mb-6 logo-container">
                  <img
                    src={logo}
                    className="login-logo"
                    alt="login-logo"
                  />
                  <h3 className="ml-2">{appName}</h3>
                </div>
                <div className="form-container">
                  <div className="field text-left">
                    <span className="p-input-icon-left">
                      <i className="pi pi-phone"></i>
                      <InputText
                        autoComplete="new-password"
                        type="text"
                        placeholder="(00) 0 0000-0000"
                        value={phone}
                        onChange={e => setPhone(maskPhone(e.target.value))}
                        autoFocus
                        className={classNames("pt-3 pb-3 ", { "p-invalid": submitted && !phone })}
                      />
                    </span>
                    {submitted && !phone && <small className="p-invalid">Telefone é obrigatório.</small>}
                  </div>
                </div>
                <div className="button-container">
                  <Button type="submit" disabled={loading} label={loading ? "AUTENTICANDO..." : "ENVIAR CÓDIGO"} className="p-3" />
                </div>
              </div>
            </form>
          ) : !changePassword ? (
            <form
              onSubmit={e => {
                e.preventDefault();
                _confirmCodePhone();
              }}>
              <div className="flex flex-column">
                <div className="flex align-items-center mb-6 logo-container">
                  <img
                    src={logo}
                    className="login-logo"
                    alt="login-logo"
                  />
                  <h3 className="ml-2">{appName}</h3>
                </div>
                <div className="form-container">
                  <div className="field text-left">
                    <span className="p-input-icon-left">
                      <i className="pi pi-key"></i>
                      <InputText
                        autoComplete="new-password"
                        type="password"
                        placeholder="Código Secreto"
                        value={code}
                        onChange={e => setCode(e.target.value)}
                        className={classNames("pt-3 pb-3 ", { "p-invalid": submitted && !code })}
                      />
                    </span>
                    {submitted && !code && <small className="p-invalid">Código é obrigatório.</small>}
                  </div>
                </div>
                <div className="button-container">
                  <Button type="submit" disabled={loading} label={loading ? "VALIDANDO..." : "VALIDAR"} className="p-3" />
  
                  <Button
                    type="submit"
                    onClick={() => {
                      setConfirm(false);
                      setTime(0);
                    }}
                    label="TENTAR OUTRO NÚMERO"
                    className="p-3 p-button-danger p-button-text"
                  />
                </div>
              </div>
            </form>
          ) : (
            <form
              onSubmit={e => {
                e.preventDefault();
                _changePassword();
              }}>
              <div className="flex flex-column">
                <div className="flex align-items-center mb-6 logo-container">
                  <img
                    src={logo}
                    className="login-logo"
                    alt="login-logo"
                  />
                  <h3 className="ml-2">{appName}</h3>
                </div>
                <div className="form-container">
                  <div className="field text-left">
                    <span className="p-input-icon-left">
                      <i className="pi pi-key"></i>
                      <InputText
                        autoComplete="new-password"
                        type="number"
                        placeholder="Novo Código"
                        value={newPassword}
                        onChange={e => setNewPassword(e.target.value)}
                        className={classNames("pt-3 pb-3 ", { "p-invalid": submitted && !newPassword })}
                      />
                    </span>
                    {submitted && !newPassword && <small className="p-invalid">Novo código é obrigatório.</small>}
                  </div>
                </div>
                <div className="button-container">
                  <Button type="submit" disabled={loading} label={loading ? "ALTERANDO..." : "ALTERAR"} className="p-3" />
                </div>
              </div>
            </form>
          )
        )}
        {loadFranchise ? (null) : (
          <div className="login-footer flex align-items-center">
            <span>Todos direitos reservados a Vamos CAP 2023</span>
          </div>
        )}
      </div>
      <div ref={recaptchaWrapperRef}>
        <div id="recaptcha-container"></div>
      </div>
    </div>
  );
};
